module.exports = __webpack_public_path__ + "static/happy-couple-walking-on-the-sidewalk-mobile.7a9fa62d.webp";